/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:46:47
 * @LastEditTime: 2022-06-21 11:31:07
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/GiftCardAndStoreCredit/List/index.tsx
 */
import { NoDataPage } from '@/src/components';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { useI18n } from '@/src/hooks/useRouterChange';
import { getGiftCards } from '@/src/request/order';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { useQueries } from '@/src/tools/hooks/listPageHooks';
import { i18nGet } from '@/src/tools/tools';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
//import moment from 'moment';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import { useHistory } from 'react-router';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import {
  breadcrumbData,
  columns,
  ETab,
  filterList,
  tabDict,
  tabsConfig,
} from './config';
import css from './css.module.less';

const customerConvertQuery = (filter) => {
  const { currencies = [], statuses = [], types = [] } = filter;
  // console.log('filter',filter)
  const re: any = {};
  if (currencies && currencies.length > 0) {
    re.currencies = currencies.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (statuses && statuses.length > 0) {
    re.statuses = statuses.map((i) => {
      const { value } = i;
      return value;
    });
  }
  if (types && types.length > 0) {
    re.types = types.map((i) => {
      const { value } = i;
      return value;
    });
  }

  return re;
};

const permissions = () => {
  const view_gift_card_store_credit_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.view_gift_card_store_credit_listing_page,
      }),
    ],
  });
  const view_gift_card_store_credit_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.view_gift_card_store_credit_details_page,
      }),
    ],
  });
  const edit_email_mobile = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.edit_email_mobile,
      }),
    ],
  });
  const switch_status = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.switch_status,
      }),
    ],
  });
  const resend_notification = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderGiftCard,
        operation: EnumOperation.resend_notification,
      }),
    ],
  });
  return {
    view_gift_card_store_credit_listing_page,
    view_gift_card_store_credit_details_page,
    edit_email_mobile,
    switch_status,
    resend_notification,
  };
};
const OrderList = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    view_gift_card_store_credit_listing_page,
    view_gift_card_store_credit_details_page,
  } = permissions();
  const currencies = useSelector(getCurrencies());
  // console.log('currencies', currencies);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  /* 分页 */
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [noProducts, setNoProducts] = useState(true);
  const [sortBy, setSortBy] = useState<any>({});
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  const [tabsActive, setTabsActive] = useState(ETab.all);
  const isTabOnActive = tabsActive === ETab.active;
  const isTabOnInActive = tabsActive === ETab.inactive;

  //console.log('tabsActive', tabsActive);
  //分页配置
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { clearSearchState, queryProps, search } = useQueries(
    filterList(currencies, { isTabOnActive, isTabOnInActive }, getI18n),
    [],
    customerConvertQuery,
  );

  const statuses = tabDict[tabsActive];
  const conditions = {
    statuses,
    ...search,
    ...(Object.keys(sortBy).length ? { sortBy } : {}),
  };

  const buttonMenu = [
    //不知道
    //Bulk Edit
    // {
    //   key: 1,
    //   value: 'Invoices',
    //   function: () => {
    //     if (selectedRowKeys.length > 0) {
    //       printInvoice({ orderUuids: selectedRowKeys }).then((data) => {
    //         console.log(data, 'data=====>');
    //       });
    //     }
    //   },
    // },
  ];

  //tab改变事件
  const tabChange = (activeKey) => {
    // clearTableState();
    clearSearchState();
    setCurrent(0);
    setSortBy({});
    // setStartDate('');
    // setEndDate('');
    setTabsActive(activeKey);
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }

    getGiftCards(current * pageSize, pageSize, conditions)
      .then((res) => {
        //console.log(res);
        const { results, totalCount } = res;
        setData(results || []);
        setTotal(totalCount);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (view_gift_card_store_credit_listing_page) {
      getGiftCards(current * pageSize, pageSize, conditions).then((res) => {
        //console.log(res);
        const { results, totalCount } = res;
        setLoading(false);
        setData(results || []);
        setTotal(totalCount);
        setNoProducts(!totalCount);
      });
    } else {
      setLoading(false);
    }
  }, []);

  useAfterDidMountEffect(() => {
    if (view_gift_card_store_credit_listing_page) {
      getProduct(() => void 0);
    }
  }, [current]);

  useAfterDidMountEffect(() => {
    if (view_gift_card_store_credit_listing_page) {
      if (!current) {
        getProduct(() => void 0);
      } else {
        setCurrent(0);
      }
    }
  }, [
    pageSize,
    search,
    sortBy,
    //startDate, endDate
  ]);

  const pageLayoutProps = {
    title: getI18n(
      'giftCard.giftCardList.giftCardAndStoreCredit_List_pageLayoutProps_title',
    ),
    //addText: 'Create New Order',
    //addFun,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig(getI18n),
  };

  // const handleTimePickerOnChange = (data) => {
  //   if (data) {
  //     setStartDate(data[0].format('YYYY-MM-DD'));
  //     setEndDate(data[1].format('YYYY-MM-DD'));
  //   } else {
  //     setStartDate('');
  //     setEndDate('');
  //   }
  // };

  const handleGotoEdit = (uuid) => {
    history.push(`/order/giftCard/edit/${uuid}`);
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData(getI18n)}></Breadcrumb>
      {noProducts ? (
        <NoDataPage
          title={getI18n(
            'giftCard.giftCardList.giftCardAndStoreCredit_List_retun_nodatapage_Yes_title',
          )}
        />
      ) : (
        <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
          <GlobalTable
            id='OrderGiftCardList'
            //showTimePicker
            // timePickerValue={[
            //   startDate ? moment(startDate) : '',
            //   endDate ? moment(endDate) : '',
            // ]}
            // timePickerOnChange={handleTimePickerOnChange}
            queryProps={queryProps}
            dataSource={data || []}
            columns={columns(
              handleGotoEdit,
              !view_gift_card_store_credit_details_page,
              getI18n,
            )}
            buttonMenu={buttonMenu}
            rowKey='uuid'
            pagination={paginationProps}
            current={current}
            setCurrent={setCurrent}
            pageSize={pageSize}
            hideBulkEditor
            setPageSize={setPageSize}
            total={total}
            holdHeader
            hideRowSelection
            hidePagination={total == 0}
            onRow={(record) => ({
              onClick: view_gift_card_store_credit_details_page
                ? () => handleGotoEdit(record.uuid)
                : null,
            })}
            onChange={(_, s, sort) => {
              //console.log('sort', sort);
              const ascent = sort.order == 'ascend' ? true : false;
              const field = sort.columnKey;
              setSortBy({ field, ascent });
            }}
            loading={loading}
          />
        </ListPageLayout>
      )}
    </React.Fragment>
  );
};

export default memo(OrderList);
